// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Streamers__root-ecc0b9 {
  position: relative;
  display: none;
}

.Streamers__is-visible-f67d74 {
  display: flex;
}

.Streamers__container-dd5238 {
  --streamers-list-width: 208px;
  flex-shrink: 0;
  width: var(--streamers-list-width);
  overflow: hidden;
  padding-inline-end: 8px;
  box-sizing: border-box;
  overflow-y: auto;
}

.Streamers__exit-a58af5 {
  width: var(--streamers-list-width);
}

.Streamers__exit-active-f1cc1c {
  width: 0;
  transition: width 100ms ease-out;
}

.Streamers__enter-ed6fc1 {
  width: 0;
}

.Streamers__enter-active-faac44 {
  width: var(--streamers-list-width);
  transition: width 100ms ease-out;
}

.Streamers__video-container-e92492 {
  margin-top: 8px;
  width: 200px;
  height: 152px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  z-index: 0;
  background-color: var(--addition-100);
  display: flex;
  align-items: center;
  justify-content: center;
}

.Streamers__video-container-e92492:first-child {
  margin-top: 64px;
}

.Streamers__video-container-e92492 video {
  object-fit: cover !important;
  height: 100%;
}

.Streamers__toggle-opponents-f89a69 {
  position: absolute;
  right: -56px;
  top: 0;
  height: 100%;
  width: 56px;
  z-index: 1;
  cursor: pointer;
}

.Streamers__toggle-opponents-f89a69:hover .Streamers__icon-ea421a {
  background-color: var(--addition-110_50);
}

.Streamers__toggle-opponents-f89a69:active .Streamers__icon-ea421a {
  background-color: var(--addition-110_60);
}

.Streamers__icon-ea421a {
  border-radius: 50%;
  fill: var(--addition-50);
  padding: 8px;
  background-color: var(--addition-110_40);
}`, "",{"version":3,"sources":["webpack://./src/main/LiveStreaming/SharedComponents/Streamers/styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,6BAAA;EACA,cAAA;EACA,kCAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kCAAA;AACF;;AAEA;EACE,QAAA;EACA,gCAAA;AACF;;AAEA;EACE,QAAA;AACF;;AAEA;EACE,kCAAA;EACA,gCAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,4BAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;AACF;;AAEA;EACE,wCAAA;AACF;;AAEA;EACE,wCAAA;AACF;;AAEA;EACE,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,wCAAA;AACF","sourcesContent":[".root {\n  position: relative;\n  display: none;\n}\n\n.is-visible {\n  display: flex;\n}\n\n.container {\n  --streamers-list-width: 208px;\n  flex-shrink: 0;\n  width: var(--streamers-list-width);\n  overflow: hidden;\n  padding-inline-end: 8px;\n  box-sizing: border-box;\n  overflow-y: auto;\n}\n\n.exit {\n  width: var(--streamers-list-width);\n}\n\n.exit-active {\n  width: 0;\n  transition: width 100ms ease-out;\n}\n\n.enter {\n  width: 0;\n}\n\n.enter-active {\n  width: var(--streamers-list-width);\n  transition: width 100ms ease-out;\n}\n\n.video-container {\n  margin-top: 8px;\n  width: 200px;\n  height: 152px;\n  border-radius: 8px;\n  overflow: hidden;\n  position: relative;\n  z-index: 0;\n  background-color: var(--addition-100);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.video-container:first-child {\n  margin-top: 64px;\n}\n\n.video-container video {\n  object-fit: cover !important;\n  height: 100%;\n}\n\n.toggle-opponents {\n  position: absolute;\n  right: -56px;\n  top: 0;\n  height: 100%;\n  width: 56px;\n  z-index: 1;\n  cursor: pointer;\n}\n\n.toggle-opponents:hover .icon {\n  background-color: var(--addition-110_50);\n}\n\n.toggle-opponents:active .icon {\n  background-color: var(--addition-110_60);\n}\n\n.icon {\n  border-radius: 50%;\n  fill: var(--addition-50);\n  padding: 8px;\n  background-color: var(--addition-110_40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Streamers__root-ecc0b9`,
	"is-visible": `Streamers__is-visible-f67d74`,
	"isVisible": `Streamers__is-visible-f67d74`,
	"container": `Streamers__container-dd5238`,
	"exit": `Streamers__exit-a58af5`,
	"exit-active": `Streamers__exit-active-f1cc1c`,
	"exitActive": `Streamers__exit-active-f1cc1c`,
	"enter": `Streamers__enter-ed6fc1`,
	"enter-active": `Streamers__enter-active-faac44`,
	"enterActive": `Streamers__enter-active-faac44`,
	"video-container": `Streamers__video-container-e92492`,
	"videoContainer": `Streamers__video-container-e92492`,
	"toggle-opponents": `Streamers__toggle-opponents-f89a69`,
	"toggleOpponents": `Streamers__toggle-opponents-f89a69`,
	"icon": `Streamers__icon-ea421a`
};
module.exports = ___CSS_LOADER_EXPORT___;
